export default "__VITE_ASSET__ChF8x3DV__"